export const convertSecondsToHoursHandler = (seconds?: number): string => {
  if (!seconds) {
    return '';
  }

  return (seconds / 3600).toFixed(2);
}
